import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="text-xl font-semibold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
      {title}
    </h2>
    <div className="text-sm sm:text-base text-muted-foreground leading-relaxed space-y-2">
      {children}
    </div>
  </section>
);

const SecurityPage = () => (
  <main className="min-h-screen bg-background text-foreground">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8 transition-colors duration-150">
        <ArrowLeft className="w-4 h-4" />
        Back to Home
      </Link>

      <header className="mb-10 border-b border-border pb-8">
        <div className="flex items-center gap-3 mb-4">
          <Shield className="w-8 h-8 text-primary" />
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-muted-foreground">SecureVault</span>
        </div>
        <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Security Disclosure
        </h1>
        <p className="text-sm text-muted-foreground mt-3">vault.priyanshurathod.com</p>
      </header>

      <div className="space-y-8">
        <Section title="Our Security Model">
          <p>
            SecureVault uses a zero-knowledge security model built around AES-256-GCM client-side encryption. Files are encrypted in the browser before upload so plaintext file contents are not readable by the service.
          </p>
        </Section>

        <Section title="How To Report A Vulnerability">
          <p>
            Email <a href="mailto:security@priyanshurathod.com?subject=SecureVault%20Security%20Disclosure" className="text-primary hover:underline">security@priyanshurathod.com</a> with the subject line <span className="font-mono text-foreground">SecureVault Security Disclosure</span>.
          </p>
        </Section>

        <Section title="What To Include In A Report">
          <ul className="list-disc pl-5 space-y-1">
            <li>A clear description of the vulnerability</li>
            <li>Steps to reproduce the issue</li>
            <li>The potential security impact</li>
          </ul>
        </Section>

        <Section title="Our Commitment">
          <p>We aim to respond to valid reports within 7 days and fix critical issues within 30 days.</p>
        </Section>

        <Section title="Hall Of Fame">
          <p>No public security researchers are listed yet. Responsible disclosures will be acknowledged here with permission.</p>
        </Section>
      </div>
    </div>
  </main>
);

export default SecurityPage;
